/**
 * resultHelpers.js
 */

import { doc, increment, updateDoc } from "firebase/firestore";
import { TrustIssuesRoomCollection } from "../../../assets/DatabaseCollections";
import { db } from "../../../config/firebase";

export const displayResults = async (roomID) => {
    try {
        const roomRef = doc(db, TrustIssuesRoomCollection, roomID);
        await updateDoc(roomRef, { displayResults: true });
        return true;
    } catch (error) {
        console.error("[FinalStage] Failed to update displayResults:", error);
        return false;
    }
};

export const addPointsToDatabase = async (points, roomID) => {
    try {
        const userRef = doc(db, TrustIssuesRoomCollection, roomID)

        await updateDoc(userRef, {
            totalPoints : increment(points)
        })
        return true;
    } catch (err) {
        console.error("[AddPoints] Error adding points:", err);
        return false;
    }
}